import { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Button,
  AppBar,
  Toolbar,
  CircularProgress,
  Pagination,
  Stack,
  Autocomplete,
  Grid,
  TextField,
  IconButton,
  InputLabel,
} from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import Colors from "../../assets/styles";
import AuthServices from "../../apis/AuthServices";
import moment from "moment";
import SimpleDialog from "../../components/Modal/index";
import { Controller, useForm } from "react-hook-form";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ErrorToaster, SuccessToaster } from "../../components/toaster";

const statusOptions = ["End Journey", "Engine Failure", "Interchange"];

export default function LiveTrains() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [isLoading, setIsLoading] = useState(false);
  const [locomotives, setLocomotives] = useState([]);
  const [selectedTrain, setSelectedTrain] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [filteredLocomotives, setFilteredLocomotives] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const {
    handleSubmit,
    formState: { errors },
    setValue,
    register,
    
  } = useForm({
    defaultValues: {
      trainName: "",
      allocatedDate: moment().format("YYYY-MM-DD"),
      stationName: "",
      locomotive: "",
    },
  });
  const handlePageChange = (event, newPage) => {
    setPage(newPage - 1);
  };

  const getLocomotive = async () => {
    try {
      const result = await AuthServices.allocateLocomotiveList();
      // console.log(result);
      if (result.IsSuccess == true) {
        setLocomotives(result?.Response?.Locomotives);
        setFilteredLocomotives(result.Response.Locomotives);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  useEffect(() => {
    getLocomotive();
  }, []);

  useEffect(() => {
    setValue("locomotive", selectedTrain?.LocomotiveNumber);
    setValue("imei", selectedTrain?.imie);
    setValue("mobileNum", selectedTrain?.MobileNumber);
  }, [editDialog]);
  // console.log(selectedTrain);

  const onSubmit = async (formData) => {
    const obj = {
      LocomotiveId: selectedTrain?.LocomotiveId,
      LocomotiveNumber: formData?.locomotive,
      MobileNumber: formData?.mobileNum,
      imie: formData?.imei,
    };
    try {
      const result = await AuthServices.updateLocomotive(obj);
      // console.log(result);
      if (result.IsSuccess == true) {
        SuccessToaster("Updated Successfully");
        getLocomotive();
        setEditDialog(false)
      }
    } catch (error) {
      ErrorToaster("Something went Wrong");
    }
  };
  const deleteLocomotive = async () => {
    
    try {
      const result = await AuthServices.deleteLocomotive(selectedTrain?.LocomotiveId);
      // console.log(result);
      if (result.IsSuccess == true) {
        SuccessToaster("Deleted Successfully");
        getLocomotive();
        setDeleteDialog(false)
      }
    } catch (error) {
      ErrorToaster("Something went Wrong");
    }
  };

  
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = locomotives.filter(
      (locomotive) =>
        locomotive.LocomotiveNumber.toString().includes(value) ||
        locomotive.imie?.toLowerCase().includes(value) ||
        locomotive.MobileNumber?.toLowerCase().includes(value)
    );
    setFilteredLocomotives(filtered);
  };


  return (
    <>
      <Box sx={{ mb: 3 }}>
        <AppBar position="static" color="transparent" elevation={0}>
          <Toolbar
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Box>
              <Typography
                variant="h5"
                component="h1"
                sx={{
                  color: Colors.primary,
                  fontWeight: 500,
                  letterSpacing: "1px",
                }}
              >
                Locomotive List
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Locomotive / Locomotive List
              </Typography>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>

      <SimpleDialog
        open={editDialog}
        onClose={() => {
          setEditDialog(false);
        }}
        maxWidth={"md"}
        title="Edit Locomotive "
      >
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexDirection: { xs: "column", md: "row" },
              mb: 3,
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                Locomotive
              </Typography>
              <TextField
                fullWidth
                {...register("locomotive", {
                  required: "Locomotive is Required",
                })}
                error={!!errors.locomotive}
                helperText={errors.locomotive ? errors.locomotive.message : ""}
              />
            </Box>
            <Box sx={{ width: "100%" }}>
              <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                IMEI Number
              </Typography>
              <TextField
                fullWidth
                {...register("imei", { required: "IMEI Number is Required" })}
                error={!!errors.imei} // Highlights the field in error state
                helperText={errors.imei ? errors.imei.message : ""}
              />
              </Box>
              <Box sx={{ width: "100%" }}>
                <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                  Mobile Number
                </Typography>
                <TextField
                  fullWidth
                  {...register("mobileNum", {
                    required: "Mobile Number is Required",
                  })}
                  error={!!errors.mobileNum} // Highlights the field in error state
                  helperText={errors.mobileNum ? errors.mobileNum.message : ""}
                />
              </Box>
            

          </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  bgcolor: "darkgreen",
                  "&:hover": {
                    bgcolor: "green",
                  },
                }}
              >
                Update  
              </Button>
            </Box>
        </Box>
      </SimpleDialog>

      <SimpleDialog
        open={deleteDialog}
        onClose={() => {
          setDeleteDialog(false);
        }}
       >
     <Typography variant="h6" sx={{ mb: 2 ,textAlign:"center" }}>
          Are you sure you want to Delete this Locomotive?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-around', gap: 2,mt:3 }}>
          <Button sx={{background:"grey",color:"white",px:2.5}} onClick={()=> setDeleteDialog(false)}>
            Cancel
          </Button>
          <Button variant="contained" sx={{background:"rgb(0, 100, 0)"}} onClick={deleteLocomotive} >
            Confirm
          </Button>
        </Box>
      </SimpleDialog>
      <Container
        maxWidth="xl"
        sx={{
          mt: 2,
          boxShadow: "0px 8px 24px 0 #4545501A",
          py: 2,
          backgroundColor: Colors.white,
          borderRadius:"12px"

        }}
      >
         <Box sx={{ mb: 2 }}>
            <InputLabel>Search</InputLabel>
          <TextField
            sx={{width:{md:"50%",sm:"100%",xs:'100%'}}}
            placeholder="Search by Locomotive Number, IMEI, or Mobile Number"
            value={searchTerm}
            onChange={handleSearch}
          />
        </Box>
        <TableContainer sx={{ height: "auto", overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "rgb(19 62 2)" }}>
                <TableCell sx={{ color: "white", width: "5%" }}>#</TableCell>
                <TableCell sx={{ color: "white", width: "25%" }}>
                  Locomotive
                </TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>
                  IMEI #
                </TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>
                  Mobile #
                </TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : (
                filteredLocomotives
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((train, index) => (
                    <TableRow key={train.LocomotiveId}>
                      <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                      <TableCell>{train.LocomotiveNumber}</TableCell>
                      <TableCell>{train.imie}</TableCell>
                      <TableCell>{train.MobileNumber}</TableCell>
                      <TableCell>
                        <IconButton
                          aria-label="edit"
                          onClick={() => {
                            setEditDialog(true);
                            setSelectedTrain(train);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          aria-label="delete"
                          onClick={() => {
                            setDeleteDialog(true);
                            setSelectedTrain(train);
                          }}
                        
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ mt: 2 }}
        >
          <Pagination
            count={Math.ceil(filteredLocomotives.length / rowsPerPage)}
            page={page + 1}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
            color="success"
            sx={{
              "& .MuiPaginationItem-root": {
                borderColor: "rgb(19, 62, 2)",
                color: "rgb(19, 62, 2)",
              },
              "& .MuiPaginationItem-page.Mui-selected": {
                bgcolor: "rgb(19, 62, 2)",
                color: "white",
              },
            }}
          />
        </Stack>
      </Container>
    </>
  );
}
